import { render, staticRenderFns } from "./VRManageInputs.vue?vue&type=template&id=2ca3ca76"
import script from "./VRManageInputs.vue?vue&type=script&lang=js"
export * from "./VRManageInputs.vue?vue&type=script&lang=js"
import style0 from "./VRManageInputs.vue?vue&type=style&index=0&id=2ca3ca76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports